import Icon from '../components/Icon.vue'

Icon.register({
  haykal: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496.3 202.5c17.5 2.5 21.7 26.3 6 34.7l-98.2 52.7 74.5 83.5c11.9 13.3 0 34.3-17.4 30.5l-108.6-23.7 4.1 112.5c0.4 11.7-8.9 19.2-18.4 19.2-5.2 0-10.4-2.2-14.2-7.2l-68.2-88.9-68.2 88.9c-3.8 5-9 7.2-14.2 7.2-9.5 0-18.8-7.6-18.4-19.2l4.1-112.5-108.6 23.7c-1.4 0.3-2.8 0.5-4.1 0.5-15 0-24.2-18.7-13.3-30.9l74.5-83.5-98.2-52.7c-15.6-8.4-11.5-32.2 6-34.7l110-15.4-41.8-104.3c-6.7-16.6 11.6-32.2 26.6-22.6l94 59.9 34.1-107.2c2.7-8.6 10-12.8 17.3-12.8s14.6 4.3 17.3 12.8l34.1 107.2 94-59.9c15-9.6 33.3 6 26.6 22.6l-41.8 104.3zM338.5 311.7l-35.6-39.9 46.9-25.2-52.6-7.4 20-49.9-45 28.6-16.3-51.2-16.3 51.2-45-28.6 20 49.9-52.6 7.4 46.9 25.2-35.6 39.9 51.9-11.3-2 53.8 32.6-42.5 32.6 42.5-2-53.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/haykal.js
// module id = 1443
// module chunks = 0